var map = {
	"./de.json": "e6a6",
	"./en-us.json": "822a",
	"./en.json": "76ff",
	"./es.json": "aa6c",
	"./fr.json": "b2e9",
	"./hi.json": "8672",
	"./ru.json": "3b65",
	"./tr.json": "8839",
	"./zh-hans.json": "8ef8",
	"./zh-hant.json": "a830"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "413d";